import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 3 2", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 1, height: 2, fill: "#ce1126" }), /* @__PURE__ */ React.createElement("rect", { width: 1, height: 2, x: 1, fill: "#fcd116" }), /* @__PURE__ */ React.createElement("rect", { width: 1, height: 2, x: 2, fill: "#009460" }));
const ForwardRef = forwardRef(SvgGn);
const Memo = memo(ForwardRef);
export default Memo;
